const i = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4
};
function c(e) {
  return !!e && e in i;
}
function f() {
  if (typeof window < "u")
    try {
      const o = new URLSearchParams(window.location.search).get("debug");
      if (o === "verbose" || o === "debug")
        return "debug";
      if (o === "off" || o === "silent")
        return "silent";
      const n = window.localStorage?.getItem("origoLogLevel");
      if (c(n))
        return n;
    } catch {
    }
  return !0 ? "info" : "debug";
}
let t = f();
function s(e) {
  if (t = e, typeof window < "u")
    try {
      window.localStorage?.setItem("origoLogLevel", e);
    } catch {
    }
}
function l() {
  return t;
}
function u(e) {
  const o = `[${e}]`, n = (r) => i[r] >= i[t];
  return {
    debug: (...r) => {
      n("debug") && console.debug(o, ...r);
    },
    info: (...r) => {
      n("info") && console.info(o, ...r);
    },
    warn: (...r) => {
      n("warn") && console.warn(o, ...r);
    },
    error: (...r) => {
      n("error") && console.error(o, ...r);
    }
  };
}
function d(e) {
  const o = `${e.app} v${e.version} (${e.commit})`, n = [e.customer, e.user, e.buildDate].filter(Boolean).join(" · ");
  typeof window < "u" ? console.info(
    `%c${o}%c ${n}`,
    "font-weight:600",
    "font-weight:400;color:#888"
  ) : console.info(o, n);
}
export {
  u as createLogger,
  l as getLogLevel,
  d as logSessionHeader,
  s as setLogLevel
};
//# sourceMappingURL=index.mjs.map
